// components/common/NotFound.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FiAlertCircle, FiHome, FiLogIn } from 'react-icons/fi';

const NotFound = () => {
    const navigate = useNavigate();
    const { userProfile, company } = useAuth();

    // If user is authenticated, show simple 404 (will be wrapped in Layout with navbar)
    if (userProfile && company) {
        return (
            <div className="flex items-center justify-center py-16">
                <div className="max-w-md w-full text-center">
                    <div className="w-20 h-20 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mx-auto mb-6">
                        <FiAlertCircle className="w-10 h-10 text-red-600 dark:text-red-400" />
                    </div>

                    <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-3">404</h1>
                    <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-3">
                        Page Not Found
                    </h2>
                    <p className="text-gray-600 dark:text-gray-400 mb-6">
                        The page you're looking for doesn't exist or has been moved.
                    </p>

                    <button
                        onClick={() => navigate(`/${company.slug}/dashboard`)}
                        className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        <FiHome className="w-5 h-5" />
                        Go to Dashboard
                    </button>
                </div>
            </div>
        );
    }

    // If user is not authenticated, show full-page 404
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-zinc-900 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white dark:bg-zinc-800 rounded-2xl shadow-lg p-8 text-center">
                <div className="w-20 h-20 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mx-auto mb-6">
                    <FiAlertCircle className="w-10 h-10 text-red-600 dark:text-red-400" />
                </div>

                <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-3">404</h1>
                <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-200 mb-3">
                    Page Not Found
                </h2>
                <p className="text-gray-600 dark:text-gray-400 mb-6">
                    The page you're looking for doesn't exist or has been moved.
                </p>

                <button
                    onClick={() => navigate('/login')}
                    className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                    <FiLogIn className="w-5 h-5" />
                    Go to Login
                </button>
            </div>
        </div>
    );
};

export default NotFound;